import { State } from '../reducers/types'
import {
  ContractorActivitiesLog,
  ContractorsCounts,
  SubcontractorCounts,
} from 'src/interfaces/contractor'

export const getContractorsCounts = (state: State): ContractorsCounts | null =>
  state.contractor.contractorsCounts

export const getContractorActivitiesLogs = (state: State): ContractorActivitiesLog[] | null =>
  state.contractor.contractorActivitiesLogs

export const getSubcontractorCounts = (state: State): SubcontractorCounts | null =>
  state.contractor.subcontractorCounts
